import React, { useEffect, useRef, useState } from 'react'
import ClientsStyle from './Clients'
import Button from '../../components/Button'
import api, { customFuncsApi } from '../../api'
import { get } from 'lodash'
import Layout from '../../components/Layout'
import { ErrorModal, SuccessModal } from '../../components/Modal'
import UpdateUser from './UpdateUser'
import ClipLoader from 'react-spinners/ClipLoader'
import ScoreCreateUser from '../../components/Modal/ScoreUserCreate'
import { Empty, Button as AntButton } from 'antd'
import formatPhoneNumber from '../../helpers/PhoneWithSpaces'
import { useTranslation } from 'react-i18next'

const ScoringClients = () => {
	const errorRef = useRef()
	const updateRef = useRef()
	const createUserRef = useRef()
	const succesCreateUserRef = useRef()
	const { t } = useTranslation()

	const [sortConfig, setSortConfig] = useState({
		column: null,
		direction: null,
	})

	const [isLoading, setIsLoading] = useState(false)
	const [clientName, setClientName] = useState('')
	const [clientPhone, setClientPhone] = useState('')
	const [clientStreet, setClientStreet] = useState('')
	const [userFields, setUserFields] = useState([])

	const [clientCode, setClientCode] = useState('')
	const [maxPage, setMaxPage] = useState(10)

	const [page, setPage] = useState(0)
	const [currentPage, setCurrentPage] = useState(0)

	const [data, setData] = useState({
		data: [],
	})

	const search = (sortConfig) => {
		setIsLoading(true)
		let url = `xsSql/getClientsForScoring?${sortConfig.direction !== null ? `orderBy=[{"name": "${sortConfig.column}", "type" : "${sortConfig.direction}"}]&` : ``}$skip=${page * 10}`
		// if (
		// 	setMaxPage.length >= 1 ||
		// 	clientPhone.length >= 1 ||
		// 	clientName.length >= 1
		// )
		// 	url += "&$filter=CardType eq 'C'"
		const formattedName = clientName.includes("'")
			? clientName.replace(/'/g, "''")
			: clientName

		if (formattedName.length >= 1) url += `&CardName='${formattedName}'`
		if (clientCode.length >= 1) url += `&CardCode='${clientCode}'`
		if (clientPhone.length >= 1) url += `&U_Telephone='${clientPhone}'`
		if (clientStreet.length >= 1) url += `&StreetNo='${clientStreet}'`

		// url += `?$skip=${page * 10}`
		customFuncsApi
			.get(url, { headers: { Prefer: `odata.maxpagesize=${maxPage}` } })
			.then((res) => {
				const resData = res.data.value
				setData({
					data: [...resData],
				})
			})
			.catch((err) => {
				errorRef.current?.open(
					get(JSON.parse(err.response.data), 'error.message', ''),
				)
			})
			.finally(() => {
				setIsLoading(false)
			})
	}

	useEffect(() => {
		search(sortConfig)
		userFieldsFn()
	}, [page, maxPage, sortConfig])

	const viewItem = (v) => {
		updateRef.current?.open(v)
	}

	const handleCreateUser = () => {
		createUserRef.current?.open()
	}

	const userFieldsFn = () => {
		api
			.get('UserFieldsMD', {
				params: {
					$filter: "TableName eq 'OINV'",
					$select: 'Name,ValidValuesMD,TableName',
				},
			})
			.then((res) => {
				setUserFields(JSON.parse(res.data).value)
			})
	}

	const handleSort = (column) => {
		let direction = 'ASC'
		if (sortConfig.column === column && sortConfig.direction === 'ASC') {
			direction = 'DESC'
		} else if (
			sortConfig.column === column &&
			sortConfig.direction === 'DESC'
		) {
			direction = null
		}
		setSortConfig({ column, direction })
	}

	const UsersInvoice = (v, e) => {
		e.stopPropagation()
		const url = `/users-invoices?CardCode=${v}`
		window.open(url, '_blank')
	}

	const newDatas = () => {
		if ((data.data.length = maxPage)) {
			setPage((prevState) => prevState + Number(String(maxPage)[0]))
			setCurrentPage((prevState) => prevState + 1)
		} else {
			alert(t('noOtherInfo'))
		}
	}

	const oldData = () => {
		if (page === 0) {
			alert(t('noOtherInfo'))
		} else {
			setPage((prevState) => prevState - Number(String(maxPage)[0]))
			setCurrentPage((prevState) => prevState - 1)
		}
	}

	return (
		<Layout>
			<ClientsStyle>
				<div className="container">
					<p className="productTitle ">{t('clients')}</p>
					<div className="flex items-center justify-between flex-col sm:flex-row mt-8 mb-8 gap-5">
						<div className="flex items-center gap-5 flex-col sm:flex-row w-full">
							<input
								type="text"
								className={
									'border-[1px] border-[#DFE2E9"] p-2 rounded-md w-full'
								}
								placeholder={t('clientName')}
								defaultValue={clientName}
								onChange={(v) => setClientName(v.target.value)}
							/>
							<input
								type="text"
								className={
									'border-[1px] border-[#DFE2E9"] p-2 rounded-md w-full'
								}
								placeholder={t('clientPhone')}
								defaultValue={clientPhone}
								onChange={(v) => setClientPhone(v.target.value)}
							/>

							<input
								type="text"
								className={
									'border-[1px] border-[#DFE2E9"] p-2 rounded-md w-full'
								}
								placeholder={t('clientStreet')}
								defaultValue={clientStreet}
								onChange={(v) => setClientStreet(v.target.value)}
							/>

							<AntButton
								onClick={() => {
									search(sortConfig)
									setPage(0)
									setCurrentPage(0)
								}}
								className="w-full h-10 bg-[#0A4D68] text-white p-2 rounded-md  sm:w-[170px]"
								loading={isLoading}
							>
								{t('search')}
							</AntButton>
						</div>
						<AntButton
							className="w-full h-10 bg-[#0A4D68] text-white p-2 rounded-md  sm:w-[170px]"
							onClick={handleCreateUser}
						>
							{t('add')}
						</AntButton>
					</div>

					{isLoading ? (
						<ClipLoader
							loading={true}
							size={75}
							aria-label="Loading Spinner"
							className={'loader'}
							data-testid="loader"
						/>
					) : (
						<>
							<div className=" overflow-auto mb-8">
								<table className="w-full text-sm text-left rtl:text-right text-gray-500">
									<thead className="text-xs text-gray-700 uppercase bg-gray-50">
										<tr>
											<th
												scope="col"
												className="px-6 py-4 cursor-pointer"
												onClick={() => handleSort('CardCode')}
											>
												{t('clientCode')}{' '}
												{sortConfig.column === 'CardCode'
													? sortConfig.direction === 'ASC'
														? '↑'
														: sortConfig.direction === 'DESC'
															? '↓'
															: ''
													: ''}
											</th>
											<th
												scope="col"
												className="px-6 py-4 cursor-pointer"
												onClick={() => handleSort('CardName')}
											>
												{t('clientName')}{' '}
												{sortConfig.column === 'CardName'
													? sortConfig.direction === 'ASC'
														? '↑'
														: sortConfig.direction === 'DESC'
															? '↓'
															: ''
													: ''}
											</th>
											<th
												scope="col"
												className="px-6 py-4 cursor-pointer"
												onClick={() => handleSort('U_Telephone')}
											>
												{t('phone')}{' '}
												{sortConfig.column === 'U_Telephone'
													? sortConfig.direction === 'ASC'
														? '↑'
														: sortConfig.direction === 'DESC'
															? '↓'
															: ''
													: ''}
											</th>
											<th
												scope="col"
												className="px-6 py-4 cursor-pointer"
												onClick={() => handleSort('U_PS')}
											>
												{t('passport')}{' '}
												{sortConfig.column === 'U_PS'
													? sortConfig.direction === 'ASC'
														? '↑'
														: sortConfig.direction === 'DESC'
															? '↓'
															: ''
													: ''}
											</th>
											<th
												scope="col"
												className="px-6 py-4 cursor-pointer"
												// onClick={() => handleSort('U_Score')}
											>
												{t('status')}{' '}
												{sortConfig.column === 'U_Score'
													? sortConfig.direction === 'ASC'
														? '↑'
														: sortConfig.direction === 'DESC'
															? '↓'
															: ''
													: ''}
											</th>
											<th
												scope="col"
												className="px-6 py-4 cursor-pointer"
												// onClick={() =>
												// 	handleSort('LastInvoice.LastComment.U_Text')
												// }
											>
												{t('lastComment')}{' '}
												{sortConfig.column === 'LastInvoice.LastComment.U_Text'
													? sortConfig.direction === 'ASC'
														? '↑'
														: sortConfig.direction === 'DESC'
															? '↓'
															: ''
													: ''}
											</th>
											<th
												scope="col"
												className="px-6 py-4 cursor-pointer"
												// onClick={() => handleSort('U_MIB')}
											>
												{t('region2')}{' '}
												{sortConfig.column === 'U_MIB'
													? sortConfig.direction === 'ASC'
														? '↑'
														: sortConfig.direction === 'DESC'
															? '↓'
															: ''
													: ''}
											</th>
											<th
												scope="col"
												className="px-6 py-4 cursor-pointer"
												onClick={() => handleSort('StreetNo')}
											>
												{t('street')}{' '}
												{sortConfig.column === 'StreetNo'
													? sortConfig.direction === 'ASC'
														? '↑'
														: sortConfig.direction === 'DESC'
															? '↓'
															: ''
													: ''}
											</th>
											<th scope="col" className="px-6 py-4">
												{t('historyPurchase')}
											</th>
										</tr>
									</thead>
									<tbody>
										{data.data.length > 0 ? (
											data.data.map((v, i) => {
												return (
													<tr
														className="bg-white border-b hover:bg-gray-50"
														key={i}
														onClick={() => viewItem(v)}
													>
														<td className="px-6 py-4 font-medium text-gray-900">
															{get(v, 'CardCode', '')}
														</td>
														<td className="px-6 py-4">
															{get(v, 'CardName', '')}
														</td>
														<td className="px-6 py-4">
															{formatPhoneNumber(get(v, 'U_Telephone', ''))}
														</td>
														<td className="px-6 py-4">{get(v, 'U_PS', '')}</td>

														<td className="px-6 py-4">
															{get(v, 'LastInvoice.U_Score', '') !== ''
																? userFields
																		?.find((item) => item.Name === 'Score')
																		?.ValidValuesMD.find(
																			(value) =>
																				get(v, 'LastInvoice.U_Score', '') ===
																				value.Value,
																		)?.Description || ''
																: ''}
														</td>
														<td className="px-6 py-4">
															{get(v, 'LastInvoice.LastComment.U_Text', '')}
														</td>
														<td className="px-6 py-4">
															{get(v, 'ADDR_DISTRICTS.Name', '')}
														</td>
														<td className="px-6 py-4">
															{`${get(v, 'StreetNo', '') !== null && get(v, 'StreetNo', '') !== undefined ? get(v, 'StreetNo', '') : ''}
															${get(v, 'Building', '') !== null && get(v, 'Building', '') !== undefined ? get(v, 'Building', '') : ''}`}
														</td>
														<td className="px-6 py-4">
															<button
																className={
																	'bg-[#0A4D68] w-[130px] h-[40px] text-white rounded-xl'
																}
																onClick={(e) => UsersInvoice(v.CardCode, e)}
															>
																{t('historyPurchase')}
															</button>
														</td>
													</tr>
												)
											})
										) : (
											<tr>
												<td colSpan="10">
													<Empty
														description={t('noInfo')}
														image={Empty.PRESENTED_IMAGE_SIMPLE}
													/>
												</td>
											</tr>
										)}
									</tbody>
								</table>
							</div>
							<div className="topCard">
								<select
									value={maxPage}
									className="w-[70px] rounded-xl flex text-center"
									onChange={(e) => {
										setMaxPage(e.target.value)
										setPage(0)
										setCurrentPage(0)
									}}
								>
									<option value="10">10</option>
									<option value="20">20</option>
									<option value="30">30</option>
									<option value="50">50</option>
									<option value="80">80</option>
								</select>
								<div className="flex items-center gap-2 ">
									<Button
										disabled={page === 0}
										className={'btn'}
										onClick={oldData}
									>
										{'<'}
									</Button>
									<p>{currentPage + 1}</p>
									<Button
										// disabled={data.data.length !== maxPage}
										className={'btn'}
										onClick={newDatas}
									>
										{'>'}
									</Button>
								</div>
							</div>
						</>
					)}
				</div>
			</ClientsStyle>
			<ErrorModal getRef={(r) => (errorRef.current = r)} />
			<UpdateUser
				getRef={(ref) => (updateRef.current = ref)}
				onUpdated={() => search(sortConfig)}
			/>
			<ScoreCreateUser
				getRef={(ref) => (createUserRef.current = ref)}
				onConfirm={() => succesCreateUserRef.current?.open(t('sucClient'))}
				onClose={() => {
					succesCreateUserRef.current?.close()
				}}
				onUpdated={() => search(sortConfig)}
			/>
			<SuccessModal
				getRef={(r) => {
					succesCreateUserRef.current = r
				}}
			/>
		</Layout>
	)
}

export default ScoringClients
